<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    >
    <slot>
    </slot>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false
    }
  },
}
</script>
